import React from 'react';
import { Radio as ChakraRadio, RadioProps as ChakraRadioProps } from '@chakra-ui/react';

export function Radio(props: ChakraRadioProps) {
  return (
    <ChakraRadio
      _focus={{
        boxShadow: 0,
      }}
      {...props}
    />
  );
}
